// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-icon {
  font-size: 14px;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: #fff;
}
.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
}
.btn-secondary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4);
}

.btn-sample {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #fff;
}
.btn-sample:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #fff;
}
.btn-danger:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);
}

.status-message {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 6px;
  white-space: nowrap;
}

.status-success {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
}

.status-error {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

/* ── Panels ── */
.formatter {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  flex: 1;
  min-height: 0;
}

.panel {
  background: #1a2736;
  border: 1px solid #2a3a4e;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: #1e2d3d;
  border-bottom: 1px solid #2a3a4e;
  flex-shrink: 0;
}

.panel-title {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input-area {
  flex: 1;
  width: 100%;
  padding: 12px 14px;
  border: none;
  background: transparent;
  color: #e0e0e0;
  font-family: "JetBrains Mono", "Fira Code", "Cascadia Code", "Consolas",
    monospace;
  font-size: 13px;
  line-height: 1.5;
  resize: none;
  outline: none;
  tab-size: 2;
  overflow: auto;
}

.input-area::placeholder {
  color: #4a5a6e;
}

.output-area {
  flex: 1;
  padding: 12px 14px;
  overflow: auto;
  font-family: "JetBrains Mono", "Fira Code", "Cascadia Code", "Consolas",
    monospace;
  font-size: 13px;
  line-height: 1.5;
}

.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #4a5a6e;
  gap: 8px;
  text-align: center;
}

.placeholder-icon {
  font-size: 36px;
  opacity: 0.5;
}

.placeholder p {
  font-size: 13px;
}

/* ── JSON Tree ── */
.json-entry {
  line-height: 1.6;
}

.json-toggle {
  cursor: pointer;
  user-select: none;
  font-size: 10px;
  color: #60a5fa;
  margin-right: 4px;
  display: inline-block;
  width: 14px;
  flex-shrink: 0;
}

.json-toggle:hover {
  color: #93c5fd;
}

.json-key {
  color: #60a5fa;
  margin-right: 4px;
}

.json-key::after {
  content: ": ";
  color: #94a3b8;
}

.json-value {
  word-break: break-all;
}

.json-string {
  color: #34d399;
}

.json-number {
  color: #f59e0b;
}

.json-boolean {
  color: #a78bfa;
}

.json-null {
  color: #6b7280;
  font-style: italic;
}

.json-bracket {
  color: #94a3b8;
}

.json-collapsed {
  color: #4a5a6e;
  font-style: italic;
  font-size: 12px;
}

.json-children {
  padding-left: 16px;
  border-left: 1px solid #2a3a4e;
}

.json-row {
  line-height: 1.6;
}

/* ── Scrollbar ── */
.output-area::-webkit-scrollbar,
.input-area::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.output-area::-webkit-scrollbar-track,
.input-area::-webkit-scrollbar-track {
  background: transparent;
}

.output-area::-webkit-scrollbar-thumb,
.input-area::-webkit-scrollbar-thumb {
  background: #2a3a4e;
  border-radius: 3px;
}

.output-area::-webkit-scrollbar-thumb:hover,
.input-area::-webkit-scrollbar-thumb:hover {
  background: #3a4a5e;
}
`, "",{"version":3,"sources":["webpack://./src/components/JsonFormatter.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd;aACW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,cAAc;EACd;aACW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":["/* ── Toolbar ── */\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 14px;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.btn-icon {\n  font-size: 14px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #3b82f6, #6366f1);\n  color: #fff;\n}\n.btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);\n}\n\n.btn-secondary {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: #fff;\n}\n.btn-secondary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4);\n}\n\n.btn-sample {\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  color: #fff;\n}\n.btn-sample:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4);\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: #fff;\n}\n.btn-danger:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);\n}\n\n.status-message {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 12px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.status-success {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n}\n\n.status-error {\n  background: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n/* ── Panels ── */\n.formatter {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.panels {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n}\n\n.panel {\n  background: #1a2736;\n  border: 1px solid #2a3a4e;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 14px;\n  background: #1e2d3d;\n  border-bottom: 1px solid #2a3a4e;\n  flex-shrink: 0;\n}\n\n.panel-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.input-area {\n  flex: 1;\n  width: 100%;\n  padding: 12px 14px;\n  border: none;\n  background: transparent;\n  color: #e0e0e0;\n  font-family: \"JetBrains Mono\", \"Fira Code\", \"Cascadia Code\", \"Consolas\",\n    monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  resize: none;\n  outline: none;\n  tab-size: 2;\n  overflow: auto;\n}\n\n.input-area::placeholder {\n  color: #4a5a6e;\n}\n\n.output-area {\n  flex: 1;\n  padding: 12px 14px;\n  overflow: auto;\n  font-family: \"JetBrains Mono\", \"Fira Code\", \"Cascadia Code\", \"Consolas\",\n    monospace;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #4a5a6e;\n  gap: 8px;\n  text-align: center;\n}\n\n.placeholder-icon {\n  font-size: 36px;\n  opacity: 0.5;\n}\n\n.placeholder p {\n  font-size: 13px;\n}\n\n/* ── JSON Tree ── */\n.json-entry {\n  line-height: 1.6;\n}\n\n.json-toggle {\n  cursor: pointer;\n  user-select: none;\n  font-size: 10px;\n  color: #60a5fa;\n  margin-right: 4px;\n  display: inline-block;\n  width: 14px;\n  flex-shrink: 0;\n}\n\n.json-toggle:hover {\n  color: #93c5fd;\n}\n\n.json-key {\n  color: #60a5fa;\n  margin-right: 4px;\n}\n\n.json-key::after {\n  content: \": \";\n  color: #94a3b8;\n}\n\n.json-value {\n  word-break: break-all;\n}\n\n.json-string {\n  color: #34d399;\n}\n\n.json-number {\n  color: #f59e0b;\n}\n\n.json-boolean {\n  color: #a78bfa;\n}\n\n.json-null {\n  color: #6b7280;\n  font-style: italic;\n}\n\n.json-bracket {\n  color: #94a3b8;\n}\n\n.json-collapsed {\n  color: #4a5a6e;\n  font-style: italic;\n  font-size: 12px;\n}\n\n.json-children {\n  padding-left: 16px;\n  border-left: 1px solid #2a3a4e;\n}\n\n.json-row {\n  line-height: 1.6;\n}\n\n/* ── Scrollbar ── */\n.output-area::-webkit-scrollbar,\n.input-area::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n.output-area::-webkit-scrollbar-track,\n.input-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.output-area::-webkit-scrollbar-thumb,\n.input-area::-webkit-scrollbar-thumb {\n  background: #2a3a4e;\n  border-radius: 3px;\n}\n\n.output-area::-webkit-scrollbar-thumb:hover,\n.input-area::-webkit-scrollbar-thumb:hover {\n  background: #3a4a5e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
